import * as React from "react";

import TextExpander from "../../smart/text-expander/text-expander";
import { spanBreak } from "../../../lib/span-break";
import type { RuntimeTheme } from "../../../lib/theme/core-themes/runtime-theme";
import { withTheme } from "styled-components";

import { TextBoxStyle, lineHeightForStyle } from "./text-box-style";
import type { TextBoxStyle as Style, TextBoxJustify } from "generator/components/text-box-types";
import type { AppKind } from "common/components/app-kind";

export interface TextBoxProps {
    readonly text: string;
    readonly style: Style;
    readonly justify: TextBoxJustify;
    readonly allCaps: boolean;
    readonly allowWrapping: boolean;
    readonly lineLimit: number;
    readonly appKind: AppKind;
}

interface Props extends TextBoxProps {
    readonly theme: RuntimeTheme;
}

class TextBoxImpl extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { text, style, justify, allCaps, allowWrapping, lineLimit, theme, appKind } = this.props;

        let content: React.ReactNode = <div>{allowWrapping ? spanBreak(text) : text}</div>;

        if (lineLimit > 0 && allowWrapping) {
            content = (
                <TextExpander lineHeight={lineHeightForStyle(style, theme)} maxLines={lineLimit} appKind={appKind}>
                    {content}
                </TextExpander>
            );
        }

        let className = "";
        if (allCaps) {
            className += "caps ";
        }

        if (allowWrapping) {
            className += "wrap ";
        }

        className += justify.toLowerCase() + " ";

        return (
            <TextBoxStyle data-test="app-text-box" className={className} textStyle={style}>
                {content}
            </TextBoxStyle>
        );
    }
}

const TextBoxView = withTheme(TextBoxImpl);
export default TextBoxView;
